<template>
  <!-- <div class="app-container"> -->
  <div class="back">
    <div class="option">
      <div class="home" @click="handlerHome">
        <img
          style="width: 32px; height: 32px"
          src="../../assets/images/ico_home@2x.png"
          alt=""
        />
      </div>
      <div class="line"></div>
      <div class="next" @click="back">
        <img
          style="width: 32px; height: 32px"
          src="../../assets/images/ico_back@2x.png"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  created() {},

  methods: {
    handlerHome() {
      this.$router.back(-1);
    },
    back() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  position: fixed;
  top: 500px;
  right: 23px;
  // right: 607px;
  width: 54px;
  height: 180px;
  background: linear-gradient(180deg, #013c79 0%, #024dac 100%);
  box-shadow: 0px 0px 24px 0px #000f1e;
  border-radius: 80px;
  border: 2px solid #70e2ee;
}
.home {
  margin: 30px 0 10px 2px;
  cursor: pointer;
}
.line {
  width: 30px;
  height: 0px;
  opacity: 1;
  border: 1px solid;
  margin-left: 2px;

  border-image: linear-gradient(
      179deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    )
    1 1;
}
.next {
  cursor: pointer;
  margin-left: 2px;
  margin-top: 10px;
}
.option {
  display: flex;
  height: 100%;
  flex-direction: column;
  margin: 20px 10px;
}
</style>
